module.exports = {
  IDNoReg:/(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}[0-9Xx]$)/,//身份证号正则
  telReg:/^1\d{10}$/, //手机号码正则
  phoneReg:/\(?0\d{2}\)?[- ]?\d{7}|0\d{2}[- ]?\d{8}/,
  success : "00",  //成功状态码
  fail:"01", //失败状态码
  questionnaireType: {
    EatingHabits: '饮食习惯',
    FamilyHistory: '家族病史',
    GynecologicalDiseases: '妇科疾病',
    LivingHabit: '生活习惯',
    LivingWorkingEnvironment: '生活工作环境',
    OldDiseases: '患有哪些疾病或曾经有过哪些症状'
  },
  extendedInformation: {
    systolicPressure : '收缩压',
    glycatedHemoglobin : '糖化血红蛋白',
    fastingBloodGlucose : '空腹血糖',
    diastolicPressure : '舒张压',
    totalCholesterol : '总胆固醇',
    highDensityLipoproteinCholesterol : '高密度脂蛋白胆固醇',
    lowDensityLipoproteinCholesterol : '低密度脂蛋白胆固醇',
    triglyceride : '甘油三酯'
  },
  diseaseTypes: {
    EsophageaCancer:	'食道癌',
    StomachCancer:	'胃癌',
    LiverCancer:	'肝癌',
    ColorectalCancer:	'结直肠癌',
    Osteoporosis:	'骨质疏松',
    PancreaticCancer:	'胰腺癌',
    CardiovascularDisease:	'心脑血管',
    LungCancer:	'肺癌',
    Leukemia:	'白血病',
    Lymphoma:	'淋巴瘤',
    BreastCancer:	'乳腺癌',
    Diabetes: '糖尿病',
    CervicalCancer:	'宫颈癌'
  },
  examinationResult: {
    z: '正常',
    g: '偏高',
    d: '偏低'
  },
  checkPhoneError:{
    none:'-02',
    success : "00",
    bindMultipleClinics : "-03",
    fail:"01",
    sendMsgCode : "-05",
    noRepeat:"10",
  },
  hwaSonBarcode:['A','C5','CA'],
};
module.exports.default = module.exports;



// WEBPACK FOOTER //
// ./src/util/config.js